import React from "react";
import McTabNav from "./McTabNav";
import "./mcPageLayout.css";

const PAGE_HEADINGS = {
  workspace: ["Morpheus · Sessions", "Sessions dashboard", "Count progress, verification and history."],
  imports: ["Morpheus · Inventory", "Inventory intake", "Sync your POS or upload inventory."],
  "prepared-data": ["Morpheus · Inventory", "Inventory review", "Review inventory and prepare it for counting."],
  sessions: ["Morpheus · Sessions", "Count sessions", "Prepare, resume and verify your counts."],
  archive: ["Morpheus · Sessions", "Archives", "Review and compare completed counts."],
  responses: ["Morpheus · Responses", "Responses", "Track actions, owners and follow-up."],
  notifications: ["Morpheus · Responses", "Response intelligence", "Track response delivery and activity."],
  "response-rules": ["Morpheus · Responses", "Response rules", "Choose when and how responses are sent."],
  sections: ["Morpheus · Organisation", "Sections", "Manage count sections and their owners."],
  sites: ["Morpheus · Organisation", "Sites", "Manage sites and response owners."],
  tickets: ["Morpheus · Support", "My tickets", "Track support requests and replies."],
  profiles: ["Morpheus · Organisation", "People", "Manage people, roles and access."],
  billing: ["Morpheus · Organisation", "Billing", "Review site usage, costs and payments."],
  config: ["Morpheus · Configuration", "Count settings", "Set count rules and response thresholds."],
  mapping: ["Morpheus · Configuration", "Field mapping", "Match inventory fields to your import."],
  categories: ["Morpheus · Configuration", "Inventory configuration", "Manage inventory rules and count groups."],
};

// Presentational only. Routing, profile access and active-tab scrolling remain
// owned by McTabNav; page actions retain the callbacks supplied by each page.
export function McPageHeader({ activeKey, subtitle, actions, actionsInHeader = false, embedded = false }) {
  const [eyebrow, title, description] = PAGE_HEADINGS[activeKey] || ["Morpheus Count", "Morpheus Count", ""];

  return (
    <div className={`mc-pageHeading${embedded ? " mc-pageHeading--embedded" : ""}`}>
      <header className="mc-pageHeader">
        <div className="mc-pageHeader__eyebrow">{eyebrow}</div>
        <h1 className="mc-pageHeader__title">{title}</h1>
        <p className="mc-pageHeader__subtitle">{subtitle ?? description}</p>
      </header>
      {!embedded && <McTabNav className="mc-pageTabs" activeKey={activeKey} />}
      {actions ? (
        <div className={`mc-pageActions${actionsInHeader ? " mc-pageActions--inHeader" : ""}`}>
          {actions}
        </div>
      ) : null}
    </div>
  );
}

export function McPageFooter() {
  return <footer className="mc-pageFooter">MatrixOS | Operate with Clarity.</footer>;
}
